export var getHeight = function getHeight(parent, element) {
  return element.getBoundingClientRect().bottom - parent.getBoundingClientRect().top;
};